import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const UserSettingComponent = React.lazy(() => import("../Components/RootComponents/UserSettingComponent"));
const UserSettingPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <UserSettingComponent />
      </Suspense>
    </Fragment>
  );
};

export default UserSettingPage;
